/** デフォルト中心座標 */
export const DEFAULT_CENTER_LAT = '32.6682688'
/** デフォルト中心座標 */
export const DEFAULT_CENTER_LNG = '130.3855907'
/** 標準倍率 */
export const DEFAULT_ZOOM = 7.75
/** ピン立て倍率 */
export const PIN_ZOOM = 17.0
